/**
 * UM audit-log policy names (JWT `PermissionPolicies` claim values). TROC-191.
 * Claims may use internal feature keys (`AuditLogReviewOthers`) or ASP.NET policy names
 * (`UM.AuditLog.Review`). The audit review endpoint policy is the authoritative grant —
 * do not gate on `ApprovalsApprove` alone.
 */
export const AUDIT_PERMISSION_POLICIES = {
  /** Mark others' audit entries reviewed — maps to BE UM.AuditLog.Review / AuditLogReviewOthers */
  REVIEW_OTHERS: 'AuditLogReviewOthers'
} as const;

export const AUDIT_PERMISSION_POLICY_ALIASES = {
  REVIEW_OTHERS: 'UM.AuditLog.Review'
} as const;

export type AuditPermissionPolicy = (typeof AUDIT_PERMISSION_POLICIES)[keyof typeof AUDIT_PERMISSION_POLICIES];

export function jwtIncludesAuditPolicy(policies: Set<string>, policy: AuditPermissionPolicy): boolean {
  if (policy === AUDIT_PERMISSION_POLICIES.REVIEW_OTHERS) {
    return policies.has(AUDIT_PERMISSION_POLICIES.REVIEW_OTHERS) || policies.has(AUDIT_PERMISSION_POLICY_ALIASES.REVIEW_OTHERS);
  }

  return false;
}
